import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DateService } from '@aiwyn/shared';

@Component({
  selector: 'app-remove-other-user-payment-method',
  templateUrl: './remove-other-user-payment-method.component.html',
  styleUrls: ['./remove-other-user-payment-method.component.scss'],
  standalone: false,
})
export class RemoveOtherUserPaymentMethodComponent {
  constructor(public dialogRef: MatDialogRef<RemoveOtherUserPaymentMethodComponent>) { }


  /**
   * Close the modal and sends true back so that the parent component knows the user wants to keep the other users payment method.
   */
  cancelChange(): void {
    this.dialogRef.close({data: false});
  }

  /**
   * Get support email.
   */
  getEmail(): string {
    const subdomain =  window.location.host.split('.')[1] ? window.location.host.split('.')[0] : false;
    return 'mailto:support@aiwyn.ai?subject=Error%20encountered&body=%0D%0A-----------------------------------------%0D%0APlace message above this line %0D%0AClient: ' + subdomain + ' %0D%0ATime: ' + DateService.getIsoDateTime();
  }

  /**
   * Close the modal and sends false back so that the parent component knows the user wants change the payment method.
   */
  changePaymentMethod() {
    this.dialogRef.close({data: true})
  }
}
